import Vue from 'vue';
import vuex from 'vuex';
import user from './modules/user.js';
import topicClass from './modules/topic-class.js';
import nav from './modules/nav';
Vue.use(vuex);

// 为应用中的所有组件提供集中式的状态存储与操作，保证所有状态以可预测的方式进行修改。
const store = new vuex.Store({
  strict: process.env.NODE_ENV !== 'production',
  // modules 对象允许将单一的 Store 拆分为多个 Store 的同时保存在单一的状态树中。
  modules: {
    user,
    nav,
    topicClass
  }
});
store.subscribeAction((action, state) => {
  console.warn(`Vuex更新key: ${action.type} > 值: ${(action.payload ? JSON.stringify(action.payload) : '').slice(0, 100)}..`);
});
export default store;



// WEBPACK FOOTER //
// ./src/vuex/store.js